// French. Keys omitted here fall back to English (see src/i18n/index.js).
// "RPilot" is a brand name and stays untranslated.
export default {
  'common.cancel': 'Annuler',
  'common.submit': 'Envoyer',
  'common.save': 'Enregistrer',
  'common.create': 'Créer',
  'common.delete': 'Supprimer',
  'common.close': 'Fermer',
  'common.retry': 'Réessayer',
  'common.confirm': 'Confirmer',
  'common.areYouSure': 'Êtes-vous sûr ?',

  'chat.startConversation': 'Commencez une conversation',
  'chat.inputPlaceholder': 'Écrivez un message...',
  'chat.inputPlaceholderNoCredits': 'Plus de crédits RPilot',
  'chat.creditsUsedUpFooter': 'Les crédits RPilot de votre équipe sont épuisés. Démarrez une nouvelle discussion une fois les crédits renouvelés.',
  'chat.newChat': 'Nouvelle discussion',
  'chat.useSkill': 'Utiliser une compétence',
  'chat.skills': 'Compétences',
  'chat.loadingSkills': 'Chargement des compétences…',
  'chat.noSkill': 'Aucune compétence',
  'chat.noSkillsAvailable': 'Aucune compétence disponible',
  'chat.appliesNextMessage': "S'applique à partir de votre prochain message",
  'chat.attachImage': 'Joindre une image',
  'chat.attachFile': 'Joindre un fichier',
  'chat.fileTooLarge': 'Fichier trop volumineux (max {size})',
  'chat.uploadFailed': "Échec de l'envoi",
  'chat.download': 'Télécharger',
  'chat.recordVoice': 'Enregistrer un message vocal',
  'chat.stopRecording': "Arrêter l'enregistrement",
  'chat.stop': 'Arrêter',
  'chat.send': 'Envoyer',
  'chat.thinking': 'Réflexion en cours…',
  'chat.thoughtProcess': 'Raisonnement',
  'chat.waitingForHost': 'En attente du tableau de bord…',
  'chat.thinkingComplete': 'Réflexion terminée',
  'chat.toolUsedOne': '1 outil utilisé',
  'chat.toolsUsedCount': '{count} outils utilisés',
  'chat.usedNames': '{names} utilisés',
  'chat.usedToolsCount': '{count} outils utilisés',
  'chat.running': 'en cours',
  'chat.details': 'Détails',
  'chat.arguments': 'Arguments',
  'chat.result': 'Résultat',
  'chat.error': 'Erreur',
  'chat.done': 'Terminé',
  'chat.openInNewTab': 'Ouvrir dans un nouvel onglet',
  'chat.openInDocsSite': 'Ouvrir dans la documentation',
  'chat.noPageContent': 'Aucun contenu disponible pour cette page.',
  'chat.goodResponse': 'Bonne réponse',
  'chat.badResponse': 'Mauvaise réponse',
  'chat.whatWentWrong': "Qu'est-ce qui n'a pas fonctionné ?",
  'chat.optionalFeedback': 'Commentaire facultatif...',

  'approval.required': 'Approbation requise',
  'approval.requiredCount': 'Approbation requise — {count} actions',
  'approval.approve': 'Approuver',
  'approval.deny': 'Refuser',
  'approval.approveAll': 'Tout approuver',
  'approval.approveSelected': 'Approuver la sélection ({count})',
  'approval.denyAll': 'Tout refuser',
  'approval.andMore': '…et {count} de plus',
  'approval.approvedChip': 'Approuvé',
  'approval.deniedChip': 'Refusé',
  'approval.timedOutChip': 'Expiré',
  'approval.countApproved': '{count} approuvées',
  'approval.countDenied': '{count} refusées',
  'approval.countTimedOut': '{count} expirées',
  'approval.timedOut': 'expiré',
  'approval.settled': 'traité',

  'header.expand': 'Agrandir',
  'header.collapse': 'Réduire',
  'header.menu': 'Menu',
  'drawer.sessions': 'Sessions',
  'drawer.skills': 'Compétences',
  'drawer.settings': 'Paramètres',
  'drawer.noSessions': "Aucune session pour l'instant",
  'drawer.chatFallbackTitle': 'Discussion {id}',
  'drawer.newSkill': 'Nouvelle compétence',
  'drawer.searchSkills': 'Rechercher des compétences...',
  'drawer.noSkillsMatch': 'Aucune compétence ne correspond à votre recherche.',
  'drawer.noSkillsYet': "Aucune compétence pour l'instant. Créez-en une pour commencer.",
  'drawer.mySkills': 'Mes compétences',
  'drawer.builtIn': 'Intégrées',
  'drawer.shared': 'Partagées',
  'drawer.showToolCalls': "Afficher les appels d'outils",
  'drawer.autoAcceptEdits': 'Accepter automatiquement les modifications',
  'drawer.darkMode': 'Mode sombre',
  'drawer.version': 'Version',
  'drawer.versionCopied': 'Copié',

  'gate.meetTitle': 'Découvrez RPilot',
  'gate.meetBody': "RPilot est votre assistant IA pour RDrive. Posez des questions sur les plans, les problèmes, les plannings et les données du projet en langage courant, et obtenez des réponses claires avec des liens directs vers l'application.",
  'gate.meetCta': 'Vous voulez RPilot pour votre équipe ? Contactez notre équipe commerciale',
  'gate.outOfCreditsTitle': "Vous n'avez plus de crédits RPilot",
  'gate.outOfCreditsBody': 'Les crédits RPilot de votre équipe sont épuisés. Contactez-nous pour les renouveler et reprendre là où vous en étiez.',
  'credits.title': 'Utilisation des crédits',
  'credits.loadFailed': "Impossible de charger l'utilisation des crédits.",
  'credits.active': 'Actif',
  'credits.fallback': 'Secours',
  'credits.exhausted': 'épuisé',
  'credits.noPools': 'Aucun pool de crédits',
  'credits.daily': 'Quotidien',
  'credits.weekly': 'Hebdomadaire',
  'credits.monthly': 'Mensuel',
  'credits.dayShort': 'J',
  'credits.weekShort': 'S',
  'credits.monthShort': 'M',
  'credits.usedNoLimit': '{label} — {spent} utilisés (sans limite)',
  'credits.balanceLine': 'Solde : {balance} crédits · réinitialisé à minuit {zone}',
  'credits.account': 'Compte',
  'credits.scopeProject': 'Projet',
  'credits.scopeTeam': 'Équipe',
  'credits.scopeMixed': 'Mixte',
  'credits.scopePool': 'Pool',
  'credits.messageNotSent': "Les crédits RPilot de votre équipe sont épuisés, ce message n'a donc pas pu être envoyé. Votre conversation est enregistrée.",
  'credits.contactUs': 'Nous contacter',

  'sales.contactSales': 'Contacter les ventes',
  'sales.requestReceived': 'Demande reçue ✓',
  'sales.submitAgain': 'Renvoyer',
  'sales.name': 'Nom',
  'sales.workEmail': 'E-mail professionnel',
  'sales.companyTeam': 'Entreprise / équipe (facultatif)',
  'sales.message': 'Message (facultatif)',
  'sales.nameRequired': 'Le nom est requis',
  'sales.emailRequired': "L'e-mail professionnel est requis",
  'sales.emailInvalid': 'Saisissez une adresse e-mail valide',
  'sales.thanks': 'Merci — notre équipe vous contactera.',
  'sales.alreadyReceived': 'Nous avons déjà reçu votre demande — nous vous contacterons.',
  'sales.genericError': "Une erreur s'est produite. Veuillez réessayer.",
  'sales.speakWithSales': "Parler à l'équipe commerciale",
  'sales.salesChatPrefill': "Bonjour, j'aimerais parler à l'équipe commerciale au sujet de RPilot pour mon équipe.",


  'skill.newSkill': 'Nouvelle compétence',
  'skill.editTitle': 'Modifier — {name}',
  'skill.viewTitle': '{name}',
  'skill.readOnlyHint': 'Cette compétence intégrée est gérée par RDrive et ne peut pas être modifiée. Pour la personnaliser pour ce projet, créez une compétence partagée portant le même nom — elle sera prioritaire ici.',
  'skill.name': 'Nom',
  'skill.nameHint': 'identifiant en kebab-case',
  'skill.nameRule': 'Doit être en kebab-case (ex. review-rfi)',
  'skill.shared': 'Partagée',
  'skill.description': 'Description',
  'skill.descriptionPlaceholder': "Ce que fait cette compétence et quand l'utiliser",
  'skill.required': 'Requis',
  'skill.tags': 'Étiquettes',
  'skill.tagsPlaceholder': 'Saisissez puis appuyez sur Entrée',
  'skill.allowedTools': 'Outils autorisés',
  'skill.allToolsAllowed': 'Tous les outils autorisés',
  'skill.instructions': 'Instructions (Markdown)',
  'skill.contentRequired': 'Le contenu est requis',
  'skill.deleteTitle': 'Supprimer la compétence',
  'skill.deleteMessage': 'Supprimer la compétence « {name} » ? Cette action est irréversible.',

  'picker.selectLocation': 'Sélectionner un emplacement',
  'picker.searchDrawings': 'Rechercher des plans...',
  'picker.planViewerFailed': 'Impossible de charger la visionneuse de plans',
  'picker.selectDrawing': 'Sélectionnez un plan à afficher',
  'picker.tapToPlace': 'Touchez une épingle pour placer le problème',
  'picker.pinPlaced': 'Épingle placée',

  'md.bold': 'Gras',
  'md.italic': 'Italique',
  'md.heading': 'Titre',
  'md.inlineCode': 'Code en ligne',
  'md.codeBlock': 'Bloc de code',
  'md.link': 'Lien',
  'md.bulletList': 'Liste à puces',
  'md.numberedList': 'Liste numérotée',
  'md.blockquote': 'Citation',
  'md.nothingToPreview': 'Rien à prévisualiser',
}
